import {RBCheck, ViewModelProperty, VmpSelectionType} from "@ldw/roesberg";
import {SearchFieldDto} from "./search-field-dto";
import {SearchDefinitionDto} from "./search-definition-dto";
import {SearchDefinition} from "./search-definition";
import { SearchSettings } from '../shared/settings/search-settings';

export class SearchDefinitionFactory {
  static fromDTO(dto: SearchDefinitionDto, settings: SearchSettings): SearchDefinition {
    const def = new SearchDefinition();
    def.databaseSearchField = this.convertField(dto.databaseSearchField);
    def.luceneSearchField = this.convertField(dto.luceneSearchField);
    def.docStatusSearchField = this.convertField(dto.docStatusSearchField);
    def.isWildCard = settings.isWildCard;
    def.searchMetaData = settings.dbSearchAsDefaultEnabled;
    this.convertList(def.docFields, dto.docFields);
    this.convertList(def.nodeFields, dto.nodeFields);
    this.convertList(def.loopFields, dto.basicFields.filter(x => x.fieldName.startsWith("Loop")));
    this.convertList(def.lncFields, dto.basicFields.filter(x => x.fieldName.startsWith("Lnc")));
    this.convertList(def.lsnFields, dto.basicFields.filter(x => x.fieldName.startsWith("Lsn")));
    this.convertList(def.customFields, dto.customFields);
    return def;
  }

  private static convertList(target: ViewModelProperty[], source: SearchFieldDto[]) {
    if (!RBCheck.isNullOrHasNoValues(source)) {
      source.forEach(dto => {
        const item = this.convertField(dto);
        if (item != undefined) {
          target.push(item);
        }
      })
    }
  }

  static convertField(dto: SearchFieldDto): ViewModelProperty | undefined {
    if (dto == undefined) {
      return undefined;
    }
    const vmp = new ViewModelProperty();
    vmp.fieldName = dto.fieldName;
    vmp.selectionType = VmpSelectionType.AutoComplete;
    vmp.fieldType = dto.fieldType;
    vmp.fieldLen = dto.fieldLen;
    vmp.listFunction = dto.listFunction;
    vmp.caption = dto.caption;
    vmp.infoText = dto.infoText;
    vmp.subGroupName = dto.subGroupName;
    return vmp;
  }


}
